export const MAP_ZOOM_TYPES = {
  LANDMASS: 6,
  CITY: 10,
  STREET: 15,
};

export const INITIAL_MAP_CENTER = { lat: 52, lng: 19 };
export const INITIAL_MAP_ZOOM = MAP_ZOOM_TYPES.LANDMASS;
